import { render, staticRenderFns } from "./CartIn.vue?vue&type=template&id=71aca5f2&scoped=true&"
import script from "./CartIn.vue?vue&type=script&lang=ts&"
export * from "./CartIn.vue?vue&type=script&lang=ts&"
import style0 from "./CartIn.vue?vue&type=style&index=0&id=71aca5f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aca5f2",
  null
  
)

export default component.exports